import {Directive, EventEmitter, inject, Output} from '@angular/core';
import {AbstractObjectSettleDialogComponent, formatDisposalOperation} from '|shared';
import {
  ApiFileService,
  DisposalConflictRequestDto,
  FileDto,
  SimplifiedDisposalScheduleDto, ValidRetentionTriggerDataResponseDto
} from '|api/document';
import {IczFormGroup, IczOption} from '@icz/angular-form-elements';
import {EntityType} from '|api/commons';
import {TranslateService} from '@ngx-translate/core';

@Directive()
export abstract class AbstractFileSettleCloseDialogComponent extends AbstractObjectSettleDialogComponent<FileDto> {
  protected translateService = inject(TranslateService);
  protected apiFileService = inject(ApiFileService);

  protected overrideValueInTabs(field: string, value: any) {
    Object.values(this.forms).forEach(form => {
      form.get(field)?.setValue(value, {emitEvent: false});
      form.recursivelyUpdateValueAndValidity();
      this.syncFormsValidityWithTabValidity();
    });
  }

  getFileTabForm(fileId: number): IczFormGroup {
    return this.forms[String(fileId)] as IczFormGroup;
  }

  updateBulkDisposalData() {
    const requestData: DisposalConflictRequestDto[] = [];
    this.objects.forEach((file: FileDto) => {
      const fileForm = this.getFileTabForm(file.id);
      requestData.push({
        id: file.id,
        entityType: EntityType.FILE,
        entityClassId: fileForm.get('entityClassId')!.value,
        yearOfRetentionPeriodStart: fileForm.get('yearOfRetentionPeriodStart')!.value
      });
    });

    this.loadingService.doLoading(
      this.apiFileService.fileGetDisposalData({
        body: requestData
      }),
      this
    ).subscribe(disposalData => {
      this.objects.forEach((file: FileDto) => {
        const fileForm = this.getFileTabForm(file.id);
        const dataForFile = disposalData[file.id];
        fileForm.get('disposalOperationCode')!.setValue(formatDisposalOperation(dataForFile.disposalOperationCode, this.translateService));
        fileForm.get('disposalYear')!.setValue(dataForFile.disposalYear);
      });
    });
  }

  patchBulkObjectRetention(validRetentions: ValidRetentionTriggerDataResponseDto) {
    if (validRetentions.globalResult) {
      this.generalTabForm.get('yearOfRetentionPeriodStart')!.setValue(validRetentions.globalResult.defaultYearOfRetentionPeriodStart);
      this.generalTabForm.get('externalRetentionTriggerIds')!.setValue(validRetentions.globalResult.externalRetentionTriggerIds);

      if (validRetentions.resultsPerEntity) {
        validRetentions.resultsPerEntity.forEach(result => {
          this.getFileTabForm(result.entityId!).get('yearOfRetentionPeriodStart')!.setValue(result.defaultYearOfRetentionPeriodStart);
          this.getFileTabForm(result.entityId!).get('externalRetentionTriggerIds')!.setValue(result.externalRetentionTriggerIds);
          this.getFileTabForm(result.entityId!).recursivelyUpdateValueAndValidity();
          this.syncFormsValidityWithTabValidity();
        });
      }
    }
  }

}

@Directive()
export abstract class AbstractFileSettleCloseFormComponent {

  @Output()
  availableDisposalSchedulesOwnChange = new EventEmitter<Nullable<SimplifiedDisposalScheduleDto[]>>();

  disposalScheduleOptions: IczOption[] = [];
}
